"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _immutable = require("immutable");
var _createReducer = _interopRequireDefault(require("../helpers/createReducer.js"));
var _Specialty = _interopRequireDefault(require("../factories/Specialty.js"));
var _LabValue = _interopRequireDefault(require("../factories/LabValue.js"));
var _UserType = _interopRequireDefault(require("../factories/UserType.js"));
var _constants = require("../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var initialState = exports.initialState = new _immutable.Map({
  us_states: new _immutable.Map(),
  countries: new _immutable.Map(),
  feedback_types: new _immutable.Set(),
  specialties: new _immutable.Map(),
  lab_values: new _immutable.Map(),
  product_page_indexes: new _immutable.Map(),
  product_index_occupations: new _immutable.Map(),
  sub_user_types: new _immutable.Set(),
  all_question_banks: new _immutable.Set(),
  bv_enums: new _immutable.Map(),
  server_time: 0,
  hubspot_institutional_landing_form_id: '',
  hubspot_id: '',
  hubspot_should_sync: false,
  hubspot_newletter_form_id: '',
  hubspot_sign_up_form_id: '',
  hubspot_cme_coach_form_id: ''
});
var reducers = {};
reducers[_constants.SERVER_TIME_FETCHED] = function (state, payload) {
  return state.set('server_time', payload.server_time);
};
reducers[_constants.STATIC_DATA_FETCHED] = function globalDataFetched(state, payload) {
  var _payload$data$attribu;
  var newState = state.set('server_time', payload.meta.server_time).set('time_difference', payload.timeDifference).set('feedback_types', new _immutable.Set()).set('all_question_banks', new _immutable.Set()).set('sub_user_types', new _immutable.Set()).set('hubspot_institutional_landing_form_id', payload.data.attributes.hubspot_institutional_landing_form_id).set('hubspot_id', payload.data.attributes.hubspot_id).set('hubspot_should_sync', ((_payload$data$attribu = payload.data.attributes.hubspot_should_sync) === null || _payload$data$attribu === void 0 ? void 0 : _payload$data$attribu.toLowerCase()) === 'true').set('hubspot_newletter_form_id', payload.data.attributes.hubspot_newletter_form_id).set('hubspot_sign_up_form_id', payload.data.attributes.hubspot_sign_up_form_id).set('hubspot_cme_coach_form_id', payload.data.attributes.hubspot_cme_coach_form_id);
  newState = (payload.data.attributes.us_states || []).reduce(function (accumulator, usState) {
    return accumulator.setIn(['us_states', usState.id], new _immutable.Map(usState));
  }, newState);
  newState = (payload.data.attributes.countries || []).reduce(function (accumulator, countries) {
    return accumulator.setIn(['countries', countries.id], new _immutable.Map(countries));
  }, newState);
  newState = (payload.data.attributes.feedback_types || []).reduce(function (accumulator, feedbackType) {
    return accumulator.update('feedback_types', function (feedbackTypes) {
      return feedbackTypes.add(feedbackType);
    });
  }, newState);
  newState = (payload.data.attributes.sub_user_types || []).reduce(function (accumulator, subUserType) {
    return accumulator.update('sub_user_types', function (subUserTypes) {
      return subUserTypes.add((0, _immutable.fromJS)(subUserType));
    });
  }, newState);
  newState = (payload.data.attributes.all_question_banks || []).reduce(function (accumulator, questionBank) {
    return accumulator.update('all_question_banks', function (allQuestionBanks) {
      return allQuestionBanks.add((0, _immutable.fromJS)(questionBank));
    });
  }, newState);
  newState = (payload.data.attributes.product_page_indexes || []).reduce(function (accumulator, productPage) {
    return accumulator.setIn(['product_page_indexes', productPage.id], new _immutable.Map(productPage));
  }, newState);
  newState = (payload.data.attributes.product_index_occupations || []).reduce(function (accumulator, productIndex) {
    return accumulator.setIn(['product_index_occupations', productIndex.id], new _immutable.Map(productIndex));
  }, newState);
  var labValuesJson = payload.included.filter(function (record) {
    return record.type === 'lab_value';
  });
  newState = labValuesJson.reduce(function (accumulator, labValue) {
    return accumulator.setIn(['lab_values', parseInt(labValue.id)], new _LabValue.default(labValue));
  }, newState);
  if (payload.data.attributes.bv_enums) {
    var enums = payload.data.attributes.bv_enums;
    newState = Object.keys(enums).reduce(function (accumulator, enumKey) {
      return accumulator.setIn(['bv_enums', enumKey], new _immutable.Map(enums[enumKey]));
    }, newState);
  }
  var specialtiesJson = payload.included.filter(function (record) {
    return record.type === 'specialty';
  });
  newState = specialtiesJson.reduce(function (accumulator, specialty) {
    return accumulator.setIn(['specialties', parseInt(specialty.id)], new _Specialty.default(specialty));
  }, newState);
  var userTypesJson = payload.included.filter(function (record) {
    return record.type === 'user_type';
  });
  newState = userTypesJson.reduce(function (accumulator, userType) {
    return accumulator.setIn(['user_types', parseInt(userType.id)], new _UserType.default(userType));
  }, newState);
  return newState;
};
var _default = exports.default = (0, _createReducer.default)(reducers, initialState);